'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _ListGroupItem = require('react-bootstrap/lib/ListGroupItem');

var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var pluralize = _utils.FormattingUtils.pluralize;

var CaseSearchResultsFilter = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultsFilter, _Component);

  function CaseSearchResultsFilter() {
    _classCallCheck(this, CaseSearchResultsFilter);

    return _possibleConstructorReturn(this, (CaseSearchResultsFilter.__proto__ || Object.getPrototypeOf(CaseSearchResultsFilter)).apply(this, arguments));
  }

  _createClass(CaseSearchResultsFilter, [{
    key: 'onFilterSelect',
    value: function onFilterSelect() {
      var _props = this.props,
          onFilterChange = _props.onFilterChange,
          filterMetaData = _props.filterMetaData;

      onFilterChange(filterMetaData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          filterMetaData = _props2.filterMetaData,
          active = _props2.active;

      return _react2.default.createElement(
        _ListGroupItem2.default,
        { active: active },
        _react2.default.createElement(
          'a',
          { className: 'item-case', onClick: this.onFilterSelect },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            filterMetaData.name
          ),
          _react2.default.createElement(
            'div',
            { className: 'count' },
            filterMetaData.count || 0,
            ' ',
            pluralize('case', filterMetaData.count)
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSearchResultsFilter;
}(_react.Component), _class2.propTypes = {
  active: _propTypes2.default.bool,
  filterMetaData: _propTypes2.default.object.isRequired,
  onFilterChange: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class;

var _default = CaseSearchResultsFilter;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(pluralize, 'pluralize', '/app/src/components/page-case-search-results/CaseSearchResultsFilter.js');
  reactHotLoader.register(CaseSearchResultsFilter, 'CaseSearchResultsFilter', '/app/src/components/page-case-search-results/CaseSearchResultsFilter.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultsFilter.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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